/**
 * Recent-search history for sidebar filter inputs, persisted to localStorage.
 *
 * Browser-native autocomplete (autocomplete="on") does not reliably accumulate
 * values in an SPA where the form submit is preventDefault-ed, so we manage the
 * history ourselves and surface it through a native <datalist> dropdown.
 */
const PREFIX = 'ggc:searchHistory:';
// Keep the most recent 20 keywords per field.
const CAP = 20;

export function getSearchHistory(key: string): string[] {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as string[]) : [];
  } catch {
    return [];
  }
}

/** Prepend a value (most-recent first), dedupe, and cap the list length. */
export function pushSearchHistory(key: string, value: string): void {
  const v = value.trim();
  if (!v) return;
  const next = [v, ...getSearchHistory(key).filter((x) => x !== v)].slice(0, CAP);
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(next));
  } catch {
    /* ignore quota / private-mode errors */
  }
}

/** Clear the recent-search history for the given field keys. */
export function clearSearchHistory(keys: string[]): void {
  try {
    keys.forEach((key) => localStorage.removeItem(PREFIX + key));
  } catch {
    /* ignore */
  }
}

/** Remove a single value from a field's recent-search history. */
export function removeSearchHistoryItem(key: string, value: string): void {
  const next = getSearchHistory(key).filter((x) => x !== value);
  try {
    if (next.length) localStorage.setItem(PREFIX + key, JSON.stringify(next));
    else localStorage.removeItem(PREFIX + key);
  } catch {
    /* ignore */
  }
}
